import {Language} from "./Languge";
import {DealerProfile} from './DealerProfile';

export class DealerBlock {
  static BLOCK_ACTIVE = 'active';
  static BLOCK_INACTIVE = 'inactive';
  public id: number;
  public title: string;
  public content: string;
  public status: boolean;
  public language: Language | number;
  public profiles: DealerProfile[];
  public statuses;
  public suppliers;
  public locked;
  public userStatus: string;
}
